module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<div class=\"progress-container\"> <% if(isSubmitDisplayed){ %> <span class=\"votes-remaining\"><%- votesRemaining %></span> / <span class=\"vote-limit\"><%- voteLimit %></span> votes remaining <button <%- isSubmitDisabled? 'disabled': '' %> class=\"btn-submit\"><%- submitCopy %></button> <% } else{ %> <span class=\"user-vote\"><%- votes %></span><%- text %> <% } %> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<div class="progress-container"> ');__stack.lineno=1; if(isSubmitDisplayed){ ; buf.push(' <span class="votes-remaining">', (__stack.lineno=1,  votesRemaining ), '</span> / <span class="vote-limit">', (__stack.lineno=1,  voteLimit ), '</span> votes remaining <button ', (__stack.lineno=1,  isSubmitDisabled? 'disabled': '' ), ' class="btn-submit">', (__stack.lineno=1,  submitCopy ), '</button> ');__stack.lineno=1; } else{ ; buf.push(' <span class="user-vote">', (__stack.lineno=1,  votes ), '</span>', (__stack.lineno=1,  text ), ' ');__stack.lineno=1; } ; buf.push(' </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/progress.ejs
// module id = 221
// module chunks = 0